import React from 'react';
import './AdminToolbar.css';

/**
 * @param {{
 *   label: React.ReactNode,
 *   count?: number | string | null,
 *   status?: React.ReactNode,
 *   actions?: React.ReactNode,
 *   className?: string
 * }} props
 */
function AdminToolbar({
  label,
  count = null,
  status = null,
  actions = null,
  className = '',
}) {
  return (
    <header className={`au-toolbar au-scope${className ? ` ${className}` : ''}`}>
      <div className="au-toolbar__meta">
        <div className="au-toolbar__heading">
          <span className="au-toolbar__label">{label}</span>
          {count !== null && count !== undefined ? (
            <span className="au-toolbar__count">{count}</span>
          ) : null}
        </div>
        {status ? <div className="au-toolbar__status">{status}</div> : null}
      </div>
      {actions ? <div className="au-toolbar__actions">{actions}</div> : null}
    </header>
  );
}

export default AdminToolbar;
